module.exports = "/_next/static/images/56d68ad88712761c652fde762d8c0419-telmex-icon.svg";